import './Header.scss';

import Button from '../../../../components/ui/Button';

const Header = ({ image, title, listItems, buttons, bottomText }) => {
    let headerStyle = {
        backgroundImage: `url(${image})`,
    };

    return (
        <header className="Header__espnOne">
            <div className="parallex-bg" style={headerStyle}></div>
            <div className="container container--small">
                <h1 className="heading heading--large">{title}</h1>
                <div className="text text--center mt1">
                    <ul className="list list--checks list--checks-blue">
                        <li>Kijk zonder aanvullend abonnement naar ESPN 1 *</li>
                        <li>
                            Elke speelronde een selectie van live
                            Eredivisiewedstrijden
                        </li>
                        <li>
                            Uniek schakelkanaal op vrijdag met hoogtepunten uit
                            de Keuken Kampioen Divisie
                        </li>
                        <li>De TOTO KNVB Beker en Studio Europa</li>
                        <li>
                            Een selectie van live wedstrijden uit de NBA, NFL,
                            NHL en MLB
                        </li>
                        <li>En nog veel meer!</li>
                    </ul>
                </div>

                {buttons.map(btn => {
                    return (
                        <Button
                            type="primary"
                            link={btn.link}
                            label={btn.label}
                            size="large"
                            track={btn.track}
                        />
                    );
                })}

                <p className="mt1 text">
                    <i>{bottomText}</i>
                </p>
            </div>
        </header>
    );
};

export default Header;
